import { useQuery, useQueryClient } from "@tanstack/react-query";
import { TransferOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { DateTimeRange, TransferOrderPaginationOptions, TransferOrdersFilters } from "src/types";

const useTransferOrders = (
  transferOrderService: TransferOrderService,
  dateTimeRange?: DateTimeRange,
  filter?: TransferOrdersFilters,
  paginationOptions?: TransferOrderPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getTransferOrdersQueryParams(dateTimeRange, filter, paginationOptions);

  const {
    data: paginatedTransferOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedTransferOrders(queryParams),
    queryFn: () => transferOrderService.getTransferOrders(queryParams)
  });

  const refreshTransferOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedTransferOrders(),
      exact: false
    });
  };

  return { paginatedTransferOrders, fetchError, isLoading, refreshTransferOrders };
};

export { useTransferOrders };
